(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pool-cover-calculator"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const STEP_NAMES = ['Dimensions', 'Cover', 'Roller', 'Extras', 'Summary'];

    const mountInProductDetails = (root) => {
      if (!root || !root.dataset.productHandle || root.dataset.embedProductDetails === 'false') return;

      const placeholder = document.querySelector('[data-pcc-product-embed], #pcc-product-embed');
      const productDetails = document.querySelector([
        '.yv-main-product-detail',
        '.yv-product-information',
        '.product__info-container',
        '[data-product-information]',
        '[data-product-info]',
        '.product-single__meta'
      ].join(','));
      const target = productDetails || placeholder;
      if (!target) return;

      const freightWidget = productDetails?.querySelector([
        '.pasa-product-freight-wrapper',
        '[data-pasa-product-freight]',
        '[data-freight-calculator]'
      ].join(','));
      const quantityBlock = productDetails?.querySelector([
        '.product-quantity-wrapper',
        '.yv-product-quantity',
        '.product-form__quantity',
        '[data-product-quantity]'
      ].join(','));

      if (freightWidget && root.nextElementSibling === freightWidget) return;
      if (!freightWidget && quantityBlock && root.previousElementSibling === quantityBlock) return;
      if (!freightWidget && !quantityBlock && target.contains(root)) return;

      const sourceSection = root.closest('.shopify-section');
      const targetSection = target.closest('.shopify-section');
      root.classList.add('pcc-section--product-embed');

      if (freightWidget) {
        freightWidget.insertAdjacentElement('beforebegin', root);
      } else if (quantityBlock) {
        quantityBlock.insertAdjacentElement('afterend', root);
      } else if (placeholder) {
        placeholder.appendChild(root);
      } else {
        const description = productDetails.querySelector([
          '.yv-product-description',
          '.product-description',
          '.product__description',
          '[data-product-description]',
          '.yv-product-detail-description'
        ].join(','));

        if (description) {
          description.insertAdjacentElement('afterend', root);
        } else {
          target.appendChild(root);
        }
      }

      if (sourceSection && sourceSection !== targetSection) {
        sourceSection.hidden = true;
      }
    };

    const init = (root) => {
      if (!root) return;
      mountInProductDetails(root);
      if (root.dataset.pccInitialized === 'true') return;
      root.dataset.pccInitialized = 'true';

      const state = {
        step: 0,
        length: 5,
        width: 3,
        stepPosition: 'None',
        stepLength: 0,
        stepWidth: 0,
        stepDistance: 0,
        reelPosition: 'Left',
        cover: null,
        rollerFamily: null,
        roller: null,
        overcover: null,
        fittingKit: null,
        installation: null,
        installationPostcode: '',
        recycling: null
      };

      const currency = root.dataset.currency || 'AUD';
      const increment = Math.max(0.01, Number(root.dataset.billingIncrement) || 1);
      const overhangMetres = Math.max(0, Number(root.dataset.overhangMm) || 0) / 1000;
      const configuredRollerClearance = Number(root.dataset.rollerClearanceMm);
      const rollerClearanceMm = Number.isFinite(configuredRollerClearance) && configuredRollerClearance >= 0
        ? configuredRollerClearance
        : 300;
      const rollerClearanceMetres = rollerClearanceMm / 1000;
      const panels = [...root.querySelectorAll('[data-pcc-panel]')];
      const progressSteps = [...root.querySelectorAll('[data-pcc-progress-step]')];
      const backButton = root.querySelector('[data-pcc-back]');
      const nextButton = root.querySelector('[data-pcc-next]');
      const nextLabel = root.querySelector('[data-pcc-next-label]');
      const footer = root.querySelector('[data-pcc-footer]');
      const summaryLines = root.querySelector('[data-pcc-summary-lines]');
      const totalElement = root.querySelector('[data-pcc-total]');
      const message = root.querySelector('[data-pcc-message]');

      const money = (cents) => new Intl.NumberFormat('en-AU', {
        style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 2
      }).format((Number(cents) || 0) / 100);

      const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (character) => ({
        '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#039;'
      })[character]);
      const number = (value) => Math.max(0, Number(value) || 0);
      const roundArea = (value) => Math.round(value * 100) / 100;
      const suppliedLength = () => number(state.length) + overhangMetres;
      const suppliedWidth = () => number(state.width) + overhangMetres;
      const stepArea = () => state.stepPosition === 'None' ? 0 : number(state.stepLength) * number(state.stepWidth);
      const poolArea = () => roundArea((number(state.length) * number(state.width)) + stepArea());
      const coverArea = () => roundArea((suppliedLength() * suppliedWidth()) + stepArea());
      const requiredRollerLength = () => Math.round((number(state.width) + rollerClearanceMetres) * 100) / 100;
      const billedUnits = () => Math.max(1, Math.ceil((coverArea() - 0.00001) / increment));
      const billedArea = () => billedUnits() * increment;

      const optionFrom = (button, kind) => {
        if (!button) return null;
        return {
          kind,
          id: button.dataset.optionId,
          name: button.dataset.name || '',
          sku: button.dataset.sku || '',
          spec: button.dataset.spec || '',
          warranty: Number(button.dataset.warranty) || 0,
          tagline: button.dataset.tagline || '',
          variantId: button.dataset.variantId || '',
          shopifyAvailable: button.dataset.shopifyAvailable !== 'false',
          isNone: button.dataset.isNone === 'true',
          unitPriceCents: Number(button.dataset.unitPriceCents) || 0,
          priceCents: Number(button.dataset.priceCents) || 0,
          basePriceCents: Number(button.dataset.basePriceCents) || 0,
          discount: Number(button.dataset.discount) || 0,
          familyKey: button.dataset.familyKey || '',
          familyName: button.dataset.familyName || '',
          modelType: button.dataset.modelType || '',
          isTelescopic: button.dataset.isTelescopic === 'true',
          isProductVariant: button.dataset.isProductVariant === 'true',
          isLegacy: button.dataset.isLegacy === 'true',
          sizingMode: button.dataset.sizingMode || 'pool_width',
          rollerLength: Number(button.dataset.rollerLength) || 0,
          maxPoolWidth: Number.isFinite(Number(button.dataset.maxPoolWidth)) ? Number(button.dataset.maxPoolWidth) : 999,
          baseVariantPriceCents: Number(button.dataset.baseVariantPriceCents) || Number(button.dataset.priceCents) || 0,
          addonVariantId: button.dataset.addonVariantId || '',
          addonPriceCents: Number(button.dataset.addonPriceCents) || 0,
          addonName: button.dataset.addonName || ''
        };
      };

      root.querySelectorAll('[data-pcc-option="roller-model"][data-is-product-variant="true"]').forEach((button) => {
        const telescopicButton = button.cloneNode(true);
        const familyKey = button.dataset.familyKey || '';
        const sourceModelType = button.dataset.modelType || 'Stationary';
        telescopicButton.dataset.optionId = `telescopic-${button.dataset.optionId || ''}`;
        telescopicButton.dataset.isTelescopic = 'true';

        if (familyKey === 'ESSE') {
          const castorPriceCents = 9000;
          const basePriceCents = Number(button.dataset.priceCents) || 0;
          telescopicButton.dataset.modelType = 'Mobile';
          telescopicButton.dataset.name = `Essentials Telescopic Mobile Roller — ${button.dataset.rollerLength || '6'}m`;
          telescopicButton.dataset.baseVariantPriceCents = String(basePriceCents);
          telescopicButton.dataset.addonVariantId = '44722159222835';
          telescopicButton.dataset.addonPriceCents = String(castorPriceCents);
          telescopicButton.dataset.addonName = 'Elite Essentials Roller Castor Set of 4';
          telescopicButton.dataset.priceCents = String(basePriceCents + castorPriceCents);
          const title = telescopicButton.querySelector('.pcc-roller-model__content strong');
          const price = telescopicButton.querySelector('.pcc-roller-model__price');
          if (title) title.textContent = 'Essentials Telescopic Mobile Roller';
          if (price) price.textContent = money(basePriceCents + castorPriceCents);
          telescopicButton.style.order = '10';
          button.style.order = '20';
        } else {
          telescopicButton.dataset.name = String(button.dataset.name || '').replace(' Roller —', ' Telescopic Roller —');
          telescopicButton.dataset.baseVariantPriceCents = button.dataset.priceCents || '0';
          const title = telescopicButton.querySelector('.pcc-roller-model__content strong');
          if (title) title.textContent = title.textContent.replace(' Roller', ' Telescopic Roller');
          const sourceOrder = sourceModelType === 'Mobile' ? 10 : 30;
          button.style.order = String(sourceOrder);
          telescopicButton.style.order = String(sourceOrder + 10);
        }

        button.insertAdjacentElement('afterend', telescopicButton);
      });

      const SVG_NS = 'http://www.w3.org/2000/svg';
      const svgElement = (tag, attributes = {}, text = '') => {
        const element = document.createElementNS(SVG_NS, tag);
        Object.entries(attributes).forEach(([name, value]) => element.setAttribute(name, String(value)));
        if (text !== '') element.textContent = text;
        return element;
      };
      const measurementLabel = (value) => {
        const rounded = Math.round(number(value) * 100) / 100;
        return Number.isInteger(rounded) ? String(rounded) : String(rounded.toFixed(2)).replace(/0+$/, '').replace(/\.$/, '');
      };
      const addMeasurementLabel = (group, x, y, label) => {
        const labelText = String(label);
        const labelWidth = Math.max(38, 20 + (labelText.length * 10));
        group.appendChild(svgElement('rect', {
          x: x - (labelWidth / 2),
          y: y - 14,
          width: labelWidth,
          height: 28,
          rx: 14,
          class: 'pcc-svg-label-pill'
        }));
        group.appendChild(svgElement('text', {
          x,
          y: y + 0.5,
          class: 'pcc-svg-label'
        }, labelText));
      };
      const addHorizontalMeasurement = (group, x1, x2, y, label, tickDirection = 1) => {
        if (x2 - x1 < 2) return;
        group.appendChild(svgElement('path', {
          d: `M ${x1} ${y + (10 * tickDirection)} V ${y} H ${x2} V ${y + (10 * tickDirection)}`,
          class: 'pcc-svg-measure'
        }));
        addMeasurementLabel(group, (x1 + x2) / 2, y, label);
      };
      const addVerticalMeasurement = (group, x, y1, y2, label, tickDirection = 1) => {
        if (y2 - y1 < 2) return;
        group.appendChild(svgElement('path', {
          d: `M ${x + (10 * tickDirection)} ${y1} H ${x} V ${y2} H ${x + (10 * tickDirection)}`,
          class: 'pcc-svg-measure'
        }));
        addMeasurementLabel(group, x, (y1 + y2) / 2, label);
      };
      const drawPoolDiagram = () => {
        const diagram = root.querySelector('[data-pcc-pool-diagram]');
        const group = root.querySelector('[data-pcc-diagram-content]');
        if (!diagram || !group) return;
        group.replaceChildren();

        const diagramWidth = 760;
        const diagramHeight = 430;
        const poolLength = Math.max(0.1, number(state.length));
        const poolWidth = Math.max(0.1, number(state.width));
        const hasStep = state.stepPosition !== 'None';
        const requestedStepLength = hasStep ? Math.max(0.1, number(state.stepLength)) : 0;
        const requestedStepWidth = hasStep ? Math.max(0.1, number(state.stepWidth)) : 0;
        const stepLength = Math.min(poolLength, requestedStepLength);
        const stepWidth = requestedStepWidth;
        const maximumOffset = Math.max(0, poolLength - stepLength);
        const requestedOffset = state.stepPosition === 'Offset' ? number(state.stepDistance) : 0;
        const stepOffset = state.stepPosition === 'Right'
          ? maximumOffset
          : Math.min(maximumOffset, Math.max(0, requestedOffset));
        const totalHeight = poolWidth + stepWidth;
        const scale = Math.min(470 / poolLength, 245 / totalHeight);
        const poolPixelWidth = poolLength * scale;
        const poolPixelHeight = poolWidth * scale;
        const stepPixelWidth = stepLength * scale;
        const stepPixelHeight = stepWidth * scale;
        const horizontalShift = state.reelPosition === 'Right' ? -12 : 12;
        const x0 = ((diagramWidth - poolPixelWidth) / 2) + horizontalShift;
        const x1 = x0 + poolPixelWidth;
        const top = 88 + ((245 - (totalHeight * scale)) / 2);
        const mainTop = top + stepPixelHeight;
        const bottom = mainTop + poolPixelHeight;
        const stepStart = x0 + (stepOffset * scale);
        const stepEnd = stepStart + stepPixelWidth;

        let outline = `M ${x0} ${mainTop} H ${x1} V ${bottom} H ${x0} Z`;
        if (hasStep) {
          outline = [
            `M ${x0} ${mainTop}`,
            `H ${stepStart}`,
            `V ${top}`,
            `H ${stepEnd}`,
            `V ${mainTop}`,
            `H ${x1}`,
            `V ${bottom}`,
            `H ${x0}`,
            'Z'
          ].join(' ');
        }
        const waterGradientId = diagram.querySelector('[data-pcc-water-gradient]')?.id;
        group.appendChild(svgElement('path', {
          d: outline,
          class: 'pcc-svg-pool-shadow',
          transform: 'translate(0 7)'
        }));
        group.appendChild(svgElement('path', {
          d: outline,
          class: 'pcc-svg-pool',
          fill: waterGradientId ? `url(#${waterGradientId})` : '#13a6db'
        }));

        const reelOnLeft = state.reelPosition !== 'Right';
        const reelX = reelOnLeft ? x0 - 42 : x1 + 42;
        const reelTouchesStep = hasStep && (
          (reelOnLeft && state.stepPosition === 'Left') ||
          (!reelOnLeft && state.stepPosition === 'Right')
        );
        const reelTop = reelTouchesStep ? top : mainTop;
        group.appendChild(svgElement('rect', {
          x: reelX - 5,
          y: reelTop,
          width: 10,
          height: bottom - reelTop,
          rx: 2,
          class: 'pcc-svg-reel'
        }));
        group.appendChild(svgElement('rect', { x: reelX - 16, y: reelTop - 6, width: 32, height: 9, class: 'pcc-svg-reel-cap' }));
        group.appendChild(svgElement('rect', { x: reelX - 16, y: bottom - 3, width: 32, height: 9, class: 'pcc-svg-reel-cap' }));

        addHorizontalMeasurement(group, x0, x1, bottom + 24, measurementLabel(poolLength), -1);
        addVerticalMeasurement(group, x0 - 20, mainTop, bottom, measurementLabel(poolWidth), 1);

        if (hasStep) {
          const topDimensionY = top - 20;
          if (stepOffset > 0) {
            addHorizontalMeasurement(group, x0, stepStart, topDimensionY, measurementLabel(stepOffset), 1);
          }
          addHorizontalMeasurement(group, stepStart, stepEnd, topDimensionY, measurementLabel(stepLength), 1);
          const remainingLength = Math.max(0, poolLength - stepOffset - stepLength);
          if (remainingLength > 0) {
            addHorizontalMeasurement(group, stepEnd, x1, topDimensionY, measurementLabel(remainingLength), 1);
          }
          const stepMeasureX = state.stepPosition === 'Left' ? x0 - 20 : stepStart - 20;
          addVerticalMeasurement(group, stepMeasureX, top, mainTop, measurementLabel(stepWidth), 1);
        }

        diagram.setAttribute('aria-label', [
          `Pool dimensions diagram: ${measurementLabel(poolLength)} metres long by ${measurementLabel(poolWidth)} metres wide`,
          hasStep ? `${state.stepPosition} step, ${measurementLabel(stepLength)} metres long by ${measurementLabel(stepWidth)} metres wide` : 'no step',
          state.stepPosition === 'Offset' ? `${measurementLabel(stepOffset)} metres from the left` : ''
        ].filter(Boolean).join(', '));

        const stepLengthInput = root.querySelector('[data-pcc-input="stepLength"]');
        const stepDistanceInput = root.querySelector('[data-pcc-input="stepDistance"]');
        if (stepLengthInput) stepLengthInput.max = String(poolLength);
        if (stepDistanceInput) stepDistanceInput.max = String(maximumOffset);
      };

      const updateVisual = () => {
        const exactPoolArea = poolArea();
        const calculatedCoverArea = coverArea();
        root.querySelectorAll('[data-pcc-area],[data-pcc-cover-area],[data-pcc-footer-area]').forEach((el) => {
          el.textContent = `${calculatedCoverArea.toFixed(2)} m²`;
        });
        root.querySelectorAll('[data-pcc-pool-area]').forEach((el) => {
          el.textContent = `${exactPoolArea.toFixed(2)} m²`;
        });
        const coverSize = root.querySelector('[data-pcc-cover-size]');
        if (coverSize) coverSize.textContent = `${suppliedLength().toFixed(2)}m × ${suppliedWidth().toFixed(2)}m supplied size`;
        drawPoolDiagram();

        const requiredRoller = requiredRollerLength();
        const requiredRollerLabel = root.querySelector('[data-pcc-required-roller-length]');
        if (requiredRollerLabel) requiredRollerLabel.textContent = `${requiredRoller.toFixed(2)}m minimum`;
        root.querySelectorAll('[data-pcc-inline-required-roller]').forEach((label) => {
          label.textContent = `${requiredRoller.toFixed(2)}m`;
        });

        const modelButtons = [...root.querySelectorAll('[data-pcc-option="roller-model"]')];
        const familyButtons = [...root.querySelectorAll('[data-pcc-option="roller-family"]')];
        modelButtons.forEach((button) => {
          const option = optionFrom(button, 'roller-model');
          if (!option.isProductVariant) return;
          const rawFamilyName = option.familyName || option.familyKey;
          const familyLabel = option.familyKey === 'ESSE'
            ? 'Essential'
            : rawFamilyName.replace(/^Elite\s+/i, '').replace(/\s+Pool Roller$/i, '').trim();
          const suitsLength = option.familyKey === 'ESSE' ? requiredRoller : option.rollerLength;
          const suitsLabel = `${measurementLabel(suitsLength)}M Pool`;
          const modelLabel = option.familyKey === 'ESSE' && !option.isTelescopic
            ? `${familyLabel} Roller`
            : `${familyLabel}${option.isTelescopic ? ' Telescopic' : ''}${option.modelType ? ` ${option.modelType}` : ''} Roller`;
          const supplierStyleName = `${modelLabel} | Suits ${suitsLabel}`;
          button.dataset.name = supplierStyleName;
          button.setAttribute('aria-label', supplierStyleName);
          const title = button.querySelector('.pcc-roller-model__content strong');
          if (title) title.textContent = supplierStyleName;
          if (state.roller?.id === option.id) state.roller = optionFrom(button, 'roller-model');
        });
        const modelIsCompatible = (option) => option.sizingMode === 'roller_length'
          ? requiredRoller <= option.rollerLength + 0.0001
          : requiredRoller <= option.maxPoolWidth + rollerClearanceMetres + 0.0001;
        familyButtons.forEach((familyButton) => {
          const familyKey = familyButton.dataset.familyKey || '';
          const familyModels = modelButtons.filter((button) => button.dataset.familyKey === familyKey);
          const hasExactModels = familyModels.some((button) => button.dataset.isLegacy !== 'true');
          const candidates = familyModels.filter((button) => !hasExactModels || button.dataset.isLegacy !== 'true');
          const hasCompatibleModel = candidates.some((button) => {
            const option = optionFrom(button, 'roller-model');
            return modelIsCompatible(option) && option.shopifyAvailable;
          });
          familyButton.disabled = !hasCompatibleModel;
          familyButton.classList.toggle('is-unavailable', !hasCompatibleModel);
          familyButton.setAttribute('aria-disabled', hasCompatibleModel ? 'false' : 'true');
          if (!hasCompatibleModel && state.rollerFamily === familyKey) {
            state.rollerFamily = null;
            state.roller = null;
            familyButton.classList.remove('is-selected');
          }
        });

        let visibleModelCount = 0;
        const selectedFamilyModels = modelButtons.filter((button) => button.dataset.familyKey === state.rollerFamily);
        const selectedFamilyHasExactModels = selectedFamilyModels.some((button) => button.dataset.isLegacy !== 'true');
        modelButtons.forEach((button) => {
          const option = optionFrom(button, 'roller-model');
          const belongsToFamily = Boolean(state.rollerFamily) && option.familyKey === state.rollerFamily;
          const preferredModel = !selectedFamilyHasExactModels || !option.isLegacy;
          const sizeCompatible = modelIsCompatible(option);
          const compatibleProductVariants = selectedFamilyModels
            .map((candidate) => optionFrom(candidate, 'roller-model'))
            .filter((candidate) => candidate.isProductVariant && candidate.modelType === option.modelType && candidate.shopifyAvailable && modelIsCompatible(candidate));
          const minimumCompatibleLength = compatibleProductVariants.length
            ? Math.min(...compatibleProductVariants.map((candidate) => candidate.rollerLength))
            : null;
          const isBestLength = !option.isProductVariant || Math.abs(option.rollerLength - minimumCompatibleLength) < 0.0001;
          const visible = belongsToFamily && preferredModel && sizeCompatible && isBestLength;
          button.hidden = !visible;
          button.disabled = !option.shopifyAvailable;
          button.classList.toggle('is-unavailable', visible && !option.shopifyAvailable);
          button.setAttribute('aria-disabled', option.shopifyAvailable ? 'false' : 'true');
          if (visible) visibleModelCount += 1;
          if ((!visible || !option.shopifyAvailable) && state.roller?.id === option.id) {
            state.roller = null;
            button.classList.remove('is-selected');
          }
        });

        const modelPanel = root.querySelector('[data-pcc-roller-models]');
        const modelHeading = root.querySelector('[data-pcc-roller-model-heading]');
        const emptyMessage = root.querySelector('[data-pcc-roller-models-empty]');
        if (modelPanel) modelPanel.hidden = !state.rollerFamily;
        if (modelHeading && state.rollerFamily) {
          const selectedFamilyButton = familyButtons.find((button) => button.dataset.familyKey === state.rollerFamily);
          const rawFamilyName = selectedFamilyButton?.dataset.familyName || state.rollerFamily;
          const familyLabel = rawFamilyName.replace(/^Elite\s+/i, '').replace(/\s+Pool Roller$/i, '').trim();
          modelHeading.textContent = `${familyLabel} roller options`;
        }
        if (emptyMessage) emptyMessage.hidden = !state.rollerFamily || visibleModelCount > 0;

        root.querySelectorAll('[data-pcc-option="cover"]').forEach((button) => {
          const selected = optionFrom(button, 'cover');
          button.disabled = !selected.shopifyAvailable;
          button.classList.toggle('is-unavailable', !selected.shopifyAvailable);
          button.setAttribute('aria-disabled', selected.shopifyAvailable ? 'false' : 'true');
          if (!selected.shopifyAvailable && state.cover?.id === selected.id) {
            state.cover = null;
            button.classList.remove('is-selected');
          }
          const total = selected.isNone ? 0 : selected.unitPriceCents * billedUnits();
          const unitLabel = button.querySelector('[data-pcc-unit-label]');
          const totalLabel = button.querySelector('[data-pcc-option-total]');
          if (unitLabel) unitLabel.textContent = `${money(selected.unitPriceCents)}/${increment}m²`;
          if (totalLabel) totalLabel.textContent = selected.isNone ? 'Free' : money(total);
        });

        root.querySelectorAll('[data-pcc-option="extra"]').forEach((button) => {
          const selected = optionFrom(button, 'extra');
          button.disabled = !selected.shopifyAvailable;
          button.classList.toggle('is-unavailable', !selected.shopifyAvailable);
          button.setAttribute('aria-disabled', selected.shopifyAvailable ? 'false' : 'true');
        });
      };

      const showMessage = (text, isError = false) => {
        message.hidden = !text;
        message.textContent = text;
        message.classList.toggle('is-error', isError);
      };

      const canContinue = () => {
        if (state.step === 0) {
          const baseOk = number(state.length) > 0 && number(state.width) > 0;
          const stepLength = number(state.stepLength);
          const stepWidth = number(state.stepWidth);
          const offset = number(state.stepDistance);
          const stepFitsLength = stepLength > 0 && stepLength <= number(state.length);
          const offsetFits = state.stepPosition !== 'Offset' || (offset + stepLength <= number(state.length));
          const stepOk = state.stepPosition === 'None' || (stepFitsLength && stepWidth > 0 && offsetFits);
          return baseOk && stepOk;
        }
        if (state.step === 1) return Boolean(state.cover);
        if (state.step === 2) return Boolean(state.roller);
        if (state.step === 3 && state.installation && !state.installation.isNone) {
          return /^\d{4}$/.test(String(state.installationPostcode || '').trim());
        }
        return true;
      };

      const setStep = (nextStep) => {
        state.step = Math.max(0, Math.min(4, nextStep));
        panels.forEach((panel, index) => {
          const active = index === state.step;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
        progressSteps.forEach((button, index) => {
          button.classList.toggle('is-active', index === state.step);
          button.classList.toggle('is-complete', index < state.step);
          button.disabled = index > state.step;
        });
        root.querySelector('[data-pcc-step-count]').textContent = `Step ${state.step + 1} of 5`;
        root.querySelector('[data-pcc-step-name]').textContent = STEP_NAMES[state.step];
        backButton.disabled = state.step === 0;
        nextButton.disabled = !canContinue();
        if (nextLabel) nextLabel.textContent = state.step === 3 ? 'View Quote' : 'Continue';
        footer.hidden = state.step === 4;
        if (state.step === 4) renderSummary();
        root.querySelector('.pcc-card').scrollIntoView({ behavior: 'smooth', block: 'start' });
      };

      const selectButton = (button, selector) => {
        root.querySelectorAll(selector).forEach((item) => item.classList.toggle('is-selected', item === button));
      };

      root.querySelectorAll('[data-pcc-input]').forEach((input) => {
        input.addEventListener('input', () => {
          const key = input.dataset.pccInput;
          state[key] = input.type === 'number' ? number(input.value) : input.value;
          if (key === 'stepPosition') {
            root.querySelector('[data-pcc-step-fields]').hidden = state.stepPosition === 'None';
            root.querySelector('[data-pcc-offset-field]').hidden = state.stepPosition !== 'Offset';
          }
          if (key === 'reelPosition') updateVisual();
          updateVisual();
          nextButton.disabled = !canContinue();
        });
        input.addEventListener('change', () => input.dispatchEvent(new Event('input')));
      });

      root.querySelectorAll('[data-pcc-spin]').forEach((button) => {
        button.addEventListener('click', () => {
          const input = button.closest('.pcc-number-input')?.querySelector('input[type="number"]');
          if (!input) return;
          const stepAmount = Math.max(0.01, Number(input.step) || 1);
          const minimum = input.min === '' ? 0 : Number(input.min);
          const current = Number(input.value) || 0;
          const direction = button.dataset.pccSpin === 'up' ? 1 : -1;
          input.value = Math.max(minimum, Number((current + (stepAmount * direction)).toFixed(2)));
          input.dispatchEvent(new Event('input', { bubbles: true }));
        });
      });

      root.querySelectorAll('[data-pcc-option="cover"]').forEach((button) => {
        button.addEventListener('click', () => {
          state.cover = optionFrom(button, 'cover');
          selectButton(button, '[data-pcc-option="cover"]');
          nextButton.disabled = !canContinue();
        });
      });

      root.querySelectorAll('[data-pcc-option="roller-family"]').forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled) return;
          state.rollerFamily = button.dataset.familyKey || '';
          state.roller = null;
          selectButton(button, '[data-pcc-option="roller-family"]');
          root.querySelectorAll('[data-pcc-option="roller-model"],[data-pcc-option="roller-none"]').forEach((item) => item.classList.remove('is-selected'));
          updateVisual();
          nextButton.disabled = !canContinue();
        });
      });

      root.querySelectorAll('[data-pcc-option="roller-model"]').forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled || button.hidden) return;
          state.roller = optionFrom(button, 'roller-model');
          selectButton(button, '[data-pcc-option="roller-model"]');
          root.querySelector('[data-pcc-option="roller-none"]')?.classList.remove('is-selected');
          nextButton.disabled = !canContinue();
        });
      });

      root.querySelector('[data-pcc-option="roller-none"]')?.addEventListener('click', (event) => {
        const button = event.currentTarget;
        state.rollerFamily = null;
        state.roller = optionFrom(button, 'roller-none');
        root.querySelectorAll('[data-pcc-option="roller-family"],[data-pcc-option="roller-model"]').forEach((item) => item.classList.remove('is-selected'));
        button.classList.add('is-selected');
        updateVisual();
        nextButton.disabled = !canContinue();
      });

      root.querySelectorAll('[data-pcc-option="extra"]').forEach((button) => {
        button.addEventListener('click', () => {
          const group = button.dataset.extraGroup;
          const selected = optionFrom(button, 'extra');
          selected.priceCents = Number(button.dataset.priceCents) || 0;
          selected.group = group;
          state[group] = selected;
          selectButton(button, `[data-pcc-option="extra"][data-extra-group="${group}"]`);
          if (group === 'installation') {
            const postcodeField = root.querySelector('[data-pcc-installation-postcode]');
            if (postcodeField) postcodeField.hidden = selected.isNone;
            if (selected.isNone) {
              state.installationPostcode = '';
              const postcodeInput = root.querySelector('[data-pcc-input="installationPostcode"]');
              if (postcodeInput) postcodeInput.value = '';
            }
          }
          nextButton.disabled = !canContinue();
        });
      });

      const lines = () => {
        const output = [];
        if (state.cover && !state.cover.isNone) {
          output.push({
            type: 'cover',
            name: `${state.cover.name} Pool Cover`,
            meta: [state.cover.spec, state.cover.warranty ? `${state.cover.warranty}Y warranty` : '', `${poolArea().toFixed(2)} m² pool`, `${suppliedLength().toFixed(2)}m × ${suppliedWidth().toFixed(2)}m supplied`, `${coverArea().toFixed(2)} m² calculated`, `${billedArea().toFixed(2)} m² billed`].filter(Boolean).join(' · '),
            quantity: billedUnits(),
            unitCents: state.cover.unitPriceCents,
            subtotalCents: state.cover.unitPriceCents * billedUnits(),
            variantId: state.cover.variantId,
            shopifyAvailable: state.cover.shopifyAvailable
          });
        }
        if (state.roller && !state.roller.isNone) {
          output.push({
            type: 'roller',
            name: state.roller.name,
            meta: [
              state.roller.familyName ? `Family: ${state.roller.familyName}` : '',
              state.roller.modelType,
              state.roller.isTelescopic ? 'Telescopic' : '',
              state.roller.sizingMode === 'roller_length'
                ? `Selected roller length: ${state.roller.rollerLength.toFixed(2)}m`
                : `Suits pools up to ${state.roller.maxPoolWidth.toFixed(2)}m wide`,
              `Required roller length: ${requiredRollerLength().toFixed(2)}m`
            ].filter(Boolean).join(' · '),
            quantity: 1,
            unitCents: state.roller.priceCents,
            subtotalCents: state.roller.priceCents,
            variantId: state.roller.variantId,
            shopifyAvailable: state.roller.shopifyAvailable,
            baseVariantPriceCents: state.roller.baseVariantPriceCents,
            addonVariantId: state.roller.addonVariantId,
            addonPriceCents: state.roller.addonPriceCents,
            addonName: state.roller.addonName
          });
        }
        [state.overcover, state.fittingKit, state.installation, state.recycling].forEach((extra) => {
          if (extra && !extra.isNone) {
            output.push({ type:'extra', group:extra.group || '', name:extra.name, meta:extra.group === 'installation' ? `Postcode: ${state.installationPostcode}` : '', quantity:1, unitCents:extra.priceCents, subtotalCents:extra.priceCents, variantId:extra.variantId, shopifyAvailable:extra.shopifyAvailable });
          }
        });
        return output;
      };

      const quoteText = () => {
        const currentLines = lines();
        const total = currentLines.reduce((sum, line) => sum + line.subtotalCents, 0);
        return [
          'CUSTOM POOL COVER QUOTE REQUEST',
          '',
          `Measured pool: ${number(state.length).toFixed(2)}m × ${number(state.width).toFixed(2)}m`,
          `Automatic allowance: ${Math.round(overhangMetres * 1000)}mm added to length and width`,
          `Supplied cover size: ${suppliedLength().toFixed(2)}m × ${suppliedWidth().toFixed(2)}m`,
          `Pool area: ${poolArea().toFixed(2)} m²`,
          `Calculated cover area: ${coverArea().toFixed(2)} m²`,
          `Billed cover area: ${billedArea().toFixed(2)} m²`,
          `Step position: ${state.stepPosition}`,
          state.stepPosition === 'None' ? '' : `Step size: ${number(state.stepLength).toFixed(2)}m × ${number(state.stepWidth).toFixed(2)}m`,
          state.stepPosition === 'Offset' ? `Step distance from left: ${number(state.stepDistance).toFixed(2)}m` : '',
          `Reel position: ${state.reelPosition}`,
          `Minimum roller length: ${requiredRollerLength().toFixed(2)}m`,
          `Roller clearance: ${rollerClearanceMm}mm`,
          state.roller?.isNone ? 'Roller selection: No roller' : (state.roller ? `Roller selection: ${state.roller.familyName} — ${state.roller.name}` : ''),
          state.installation && !state.installation.isNone ? `Installation postcode: ${state.installationPostcode}` : '',
          '',
          'ITEMS',
          ...currentLines.map((line) => `${line.name} — Qty ${line.quantity} — ${money(line.subtotalCents)}`),
          '',
          `Estimated total: ${money(total)}`,
          'Final suitability, freight and availability are subject to confirmation.'
        ].filter(Boolean).join('\n');
      };

      const renderSummary = () => {
        const currentLines = lines();
        if (!currentLines.length) {
          summaryLines.innerHTML = '<tr><td colspan="4">No paid items selected. Go back and choose a cover, roller or extra.</td></tr>';
          totalElement.textContent = money(0);
          return;
        }
        summaryLines.innerHTML = currentLines.map((line) => `
          <tr>
            <td><strong>${escapeHtml(line.name)}</strong>${line.meta ? `<small>${escapeHtml(line.meta)}</small>` : ''}</td>
            <td>${line.quantity}</td>
            <td>${money(line.unitCents)}</td>
            <td><strong>${money(line.subtotalCents)}</strong></td>
          </tr>
        `).join('');
        totalElement.textContent = money(currentLines.reduce((sum, line) => sum + line.subtotalCents, 0));
      };

      backButton.addEventListener('click', () => setStep(state.step - 1));
      nextButton.addEventListener('click', () => { if (canContinue()) setStep(state.step + 1); });
      root.querySelector('[data-pcc-summary-back]').addEventListener('click', () => setStep(3));
      root.querySelector('[data-pcc-print]').addEventListener('click', () => window.print());
      const quotePanel = root.querySelector('[data-pcc-quote-panel]');
      const quoteButton = root.querySelector('[data-pcc-request-quote]');
      const quoteCloseButton = root.querySelector('[data-pcc-close-quote]');
      if (quoteButton && quotePanel) {
        quoteButton.addEventListener('click', () => {
          const body = root.querySelector('[data-pcc-quote-body]');
          if (body) body.value = quoteText();
          quotePanel.hidden = false;
          quotePanel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
      if (quoteCloseButton && quotePanel) quoteCloseButton.addEventListener('click', () => { quotePanel.hidden = true; });
      progressSteps.forEach((button, index) => button.addEventListener('click', () => { if (index < state.step) setStep(index); }));

      root.querySelector('[data-pcc-add-to-cart]').addEventListener('click', async (event) => {
        const button = event.currentTarget;
        showMessage('');
        const currentLines = lines();
        if (!currentLines.length) {
          showMessage('Nothing has been selected to add to cart.', true);
          return;
        }
        const unavailable = currentLines.filter((line) => line.shopifyAvailable === false);
        if (unavailable.length) {
          showMessage(`The following selection is currently unavailable in Shopify: ${unavailable.map((line) => line.name).join(', ')}.`, true);
          return;
        }
        const unmapped = currentLines.filter((line) => !line.variantId);
        if (unmapped.length) {
          showMessage(`Map a Shopify product and valid variant in the section settings for: ${unmapped.map((line) => line.name).join(', ')}.`, true);
          return;
        }

        const commonProperties = {
          'Pool length': `${number(state.length)} m`,
          'Pool width': `${number(state.width)} m`,
          'Step position': state.stepPosition,
          'Step length': state.stepPosition === 'None' ? 'N/A' : `${number(state.stepLength)} m`,
          'Step width': state.stepPosition === 'None' ? 'N/A' : `${number(state.stepWidth)} m`,
          'Step distance from left': state.stepPosition === 'Offset' ? `${number(state.stepDistance)} m` : 'N/A',
          'Reel position': state.reelPosition,
          'Automatic allowance': `${Math.round(overhangMetres * 1000)} mm added to length and width`,
          'Supplied cover length': `${suppliedLength().toFixed(2)} m`,
          'Supplied cover width': `${suppliedWidth().toFixed(2)} m`,
          'Exact pool area': `${poolArea().toFixed(2)} m²`,
          'Calculated cover area': `${coverArea().toFixed(2)} m²`
        };

        const propertiesForLine = (line) => line.type === 'cover'
            ? { ...commonProperties, 'Billing increment': `${increment} m²`, 'Billed cover area': `${billedArea().toFixed(2)} m²` }
            : line.type === 'roller'
              ? {
                  'Roller family': state.roller.familyName || state.roller.familyKey,
                  'Roller model': state.roller.name,
                  'Model type': state.roller.modelType || 'Standard',
                  'Telescopic': state.roller.isTelescopic ? 'Yes' : 'No',
                  'Selected roller length': state.roller.sizingMode === 'roller_length' ? `${state.roller.rollerLength.toFixed(2)} m` : 'N/A',
                  'Maximum compatible pool width': state.roller.sizingMode === 'pool_width' ? `${state.roller.maxPoolWidth.toFixed(2)} m` : 'N/A',
                  'Pool width': `${number(state.width).toFixed(2)} m`,
                  'Required roller length': `${requiredRollerLength().toFixed(2)} m`,
                  'Roller clearance': `${rollerClearanceMm} mm`,
                  'For pool size': `${number(state.length).toFixed(2)}m × ${number(state.width).toFixed(2)}m`
                }
              : line.group === 'installation'
                ? { 'For pool cover': state.cover ? state.cover.name : 'Not selected', 'Installation postcode': state.installationPostcode, 'Service area': 'Perth Metro only – subject to confirmation' }
                : { 'For pool cover': state.cover ? state.cover.name : 'Not selected' };

        const items = currentLines.flatMap((line) => {
          const primaryItem = {
            id: Number(line.variantId),
            quantity: line.quantity,
            properties: propertiesForLine(line)
          };
          if (line.type !== 'roller' || !line.addonVariantId) return [primaryItem];
          return [
            primaryItem,
            {
              id: Number(line.addonVariantId),
              quantity: 1,
              properties: {
                'Included with': state.roller.name,
                'Roller family': state.roller.familyName || state.roller.familyKey,
                'Telescopic/mobile configuration': 'Yes',
                'For pool size': `${number(state.length).toFixed(2)}m × ${number(state.width).toFixed(2)}m`
              }
            }
          ];
        });

        button.disabled = true;
        root.querySelector('[data-pcc-add-label]').textContent = 'Adding…';
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || result.message || 'Unable to add items to cart.');
          showMessage(`${items.length} item${items.length === 1 ? '' : 's'} added to cart.`);
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (root.dataset.redirectToCart === 'true') window.location.href = `${window.Shopify?.routes?.root || '/'}cart`;
        } catch (error) {
          showMessage(error.message || 'Unable to add items to cart.', true);
        } finally {
          button.disabled = false;
          root.querySelector('[data-pcc-add-label]').textContent = button.closest('[data-pcc-section]')?.querySelector('[data-pcc-add-label]')?.dataset.originalLabel || 'Add to Cart';
        }
      });

      const addLabel = root.querySelector('[data-pcc-add-label]');
      addLabel.dataset.originalLabel = addLabel.textContent.trim();

      const chooseDefault = (selector, stateKey) => {
        const buttons = [...root.querySelectorAll(selector)];
        const defaultButton = buttons.find((button) => button.dataset.isNone === 'true') || buttons[0];
        if (defaultButton) {
          defaultButton.classList.add('is-selected');
          const selected = optionFrom(defaultButton, 'extra');
          selected.priceCents = Number(defaultButton.dataset.priceCents) || 0;
          selected.group = defaultButton.dataset.extraGroup || '';
          state[stateKey] = selected;
        }
      };
      chooseDefault('[data-pcc-option="extra"][data-extra-group="overcover"]', 'overcover');
      chooseDefault('[data-pcc-option="extra"][data-extra-group="fittingKit"]', 'fittingKit');
      chooseDefault('[data-pcc-option="extra"][data-extra-group="installation"]', 'installation');
      chooseDefault('[data-pcc-option="extra"][data-extra-group="recycling"]', 'recycling');

      updateVisual();
      setStep(root.querySelector('[data-pcc-quote-success]') ? 4 : 0);
      if (root.querySelector('[data-pcc-quote-success]') && quotePanel) quotePanel.hidden = false;
    };

    const initializeSections = () => document.querySelectorAll('[data-pcc-section]').forEach(init);

    initializeSections();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeSections, { once:true });
    }
    document.addEventListener('shopify:section:load', (event) => {
      init(event.target.querySelector('[data-pcc-section]'));
      initializeSections();
    });
    document.addEventListener('shopify:block:select', initializeSections);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["we-want-australian-made"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const init = (section) => {
      if (!section || section.dataset.amInitialized === 'true') return;
      section.dataset.amInitialized = 'true';

      const items = section.querySelectorAll('.am-reveal');
      if (!('IntersectionObserver' in window)) {
        items.forEach((item) => item.classList.add('is-visible'));
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

      items.forEach((item) => observer.observe(item));
    };

    document.querySelectorAll('[data-australian-made-section]').forEach(init);
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-australian-made-section]')));
  })();

  } catch(e) { console.error(e); }
})();
})();
